import { useCallback, useState } from "react";
import { Button, ColumnModal, Input } from "@/components";
import { useCreatePlaylist } from "../hooks";
import { AddPlus } from "@/icons";
import { useTranslate } from "@/providers/context";
interface CreatePlaylistModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess?: (newId: number) => void;
}

export const CreatePlaylistModal = ({
  open,
  setOpen,
  onSuccess,
}: CreatePlaylistModalProps) => {
  const [name, setName] = useState("");
  const createPlaylist = useCreatePlaylist();
  const { translate } = useTranslate();
  const handleConfirm = useCallback(() => {
    if (!name) {
      return;
    }
    createPlaylist.mutate(
      { PlaylistName: name },
      {
        onSuccess: (data) => {
          if (data && onSuccess) {
            const playlists = data?.Playlists?.sort(
              (a, b) => a.PlaylistId - b.PlaylistId,
            );
            const newPlaylist = playlists?.[playlists.length - 1];
            onSuccess(newPlaylist.PlaylistId);
          }
        },
      },
    );
    setName("");
    setOpen(false);
  }, [name, createPlaylist, onSuccess, setOpen]);

  const handleCancel = useCallback(() => {
    setName("");
    setOpen(false);
  }, [setName, setOpen]);

  return (
    <ColumnModal
      title={translate("Create Playlist")}
      primaryText={translate("Create Playlist")}
      cols={3}
      open={open}
      onOpenChange={setOpen}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      triggerButton={
        <div>
          <Button
            className="w-full"
            onClick={() => setOpen(true)}
            data-testid="playlist-create-button"
            variant="secondary"
          >
            <AddPlus className="mr-1 h-6 w-6" />
            {translate("Create Playlist")}
          </Button>
        </div>
      }
    >
      <div className="my-6 px-6">
        <Input
          size="s"
          type="text"
          placeholder={translate("Example Playlist")}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
    </ColumnModal>
  );
};
